module.exports = __webpack_public_path__ + "img/cordova.70a8ebac.png";